import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import * as actions from "../../actions";
import debounce from 'lodash/debounce'
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';


import Button from '@material-ui/core/Button';

import ButtonBase from '@material-ui/core/ButtonBase';



import Grid from '@material-ui/core/Grid';

import Hidden from '@material-ui/core/Hidden';
import UpIcon from 'mdi-material-ui/ChevronDoubleUp'

import Slide from '@material-ui/core/Slide';



const style = theme => ({

  appBar:{
    background: "none",
    opacity: 1,

    position: "fixed",
    top: 0,
    left: 0,

    boxShadow: "none",

  },

  toolBar:{
    marginTop: 40,

    position: "relative",
    display: "flex",
    background: theme.palette.background.dark,
    flexDirection: "column",

    clipPath:"polygon(0 0%, 100% 0%, 100% 85%, 90% 87%, 80% 85%, 70% 89%, 60% 90%, 50% 93%, 40% 89%, 30% 92%, 20% 95%, 10% 93%, 0% 97%)",
    "-webkit-clipPath":"polygon(0 0%, 100% 0%, 100% 85%, 90% 87%, 80% 85%, 70% 89%, 60% 90%, 50% 93%, 40% 89%, 30% 92%, 20% 95%, 10% 93%, 0% 97%)",

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),

  },

  toolBarButtonMenu:{

    position: "absolute",
    top: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    maxHeight: 50,

    width: "100%",


    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
  },

  toolBarButton:{

    padding: 8,
    marginRight: theme.spacing.unit * 3,
    fontSize: 20,
    borderRadius: 0,
    color: "white",
    fontFamily: "Kanit",
    fontWeight: "900",
    fontStyle: "italic",
    textTransform: "uppercase",



    "&:hover":{
      background: "none",
      borderTop: "3px solid "+theme.palette.primary.gold,
    },

  },


  userName:{
    color: "white",
    fontSize: "1em",
    paddingTop: theme.spacing.unit * 2,
  },



  // LOGO
  logoContainer:{
    position: "absolute",
    left:0,
    top: 50,
    display:"flex",
    width: "100%",
    justifyContent:"center",

  },
  logoTitle:{
    display: "none",
    background: theme.palette.background.gold,
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    fontSize: 65,

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
  },
  logoTitleSmall:{
    display: "none",
    paddingTop: 10,
    fontSize: 55,
    color: "white",

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
  },


  /////////////////////
  /// ON NAVBAR SMALL
  /// ///////////////
  toolBarSmall:{
    marginTop: 40,
    height: 90,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",

    background: theme.palette.background.dark,

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
  },


  toolBarSmallMenuHidden:{
    marginTop: 40,
    height: 60,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    background: theme.palette.background.dark,

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
  },

  toolBarButtonMenuHidden:{
    position: "absolute",
    top: 0,
    bottom: 0,

    justifyContent: "center",
    maxHeight: 50,

    width: "100%",
    opacity: 0,
    marginTop: -150,
    display: "flex",
    justifyContent: "center",

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
  },

  smallLogoContainer:{
    position: "absolute",

    left:0,
    bottom: 0,
    display:"flex",
    width: "100%",
    justifyContent:"center"

  },
  smallLogoTitle:{
    background: theme.palette.background.gold,
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    fontSize: 40,

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
  },
  smallLogoTitleSmall:{

    fontSize: 40,
    color: "white",

    transition: theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "webkit-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-moz-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),
    "-o-transition": theme.transitions.create("all", {easing: theme.transitions.easing.sharp,duration: theme.transitions.duration.leavingScreen}),

  },

  toolBarTopMobile: {

    height: 60,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    clipPath:"polygon(0 0%, 100% 0%, 100% 85%, 90% 87%, 80% 85%, 70% 89%, 60% 90%, 50% 93%, 40% 89%, 30% 92%, 20% 95%, 10% 93%, 0% 97%)",
    "-webkit-clipPath":"polygon(0 0%, 100% 0%, 100% 85%, 90% 87%, 80% 85%, 70% 89%, 60% 90%, 50% 93%, 40% 89%, 30% 92%, 20% 95%, 10% 93%, 0% 97%)",
    background: theme.palette.background.dark,
  },


  ///// MOBILE MENU
  dialogPaper:{
    background: "transparent",
    display:"flex",
    flexDirection:"row",
    justifyContent:"flex-end",
    boxShadow: "none"
  },

  mobileMenuContainer:{
    width: 250,
    background: "#D0D0D0",
    boxShadow: theme.shadows[5]
  }

})

function Transition(props) {
  return <Slide direction="left" {...props} />;
}

class NavBar extends React.Component {
  state = {
    navBarSmall: false,
    menuHidden : false,
    currentScrollPosition: 0,

    showHomeButton: false,

    mobileMenuIsOpened: false,

    navigationData: this.props.navigationData
  }

  static contextTypes = {
    router: PropTypes.object
  }

  componentDidMount() {
    window.addEventListener('scroll',   this.handleScroll )

  }

  componentDidUpdate(prevProps){
    if(prevProps.navigationData !== this.props.navigationData)this.setState({navigationData: this.props.navigationData})
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {

    let supportPageOffset = window.pageXOffset !== undefined;
    let isCSS1Compat = ((document.compatMode || '') === 'CSS1Compat');
    let scroll = {
       x: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
       y: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
    };

    let scrollTopOffset = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop

    //let scrollTopOffset = event.target.documentElement.scrollTop
    //let scrollBottomOffset = event.target.documentElement.scrollBottom
    let menuHidden = false

    if(scrollTopOffset > 150) {

      if(this.state.currentScrollPosition < scrollTopOffset){

        this.setState({navBarSmall: true, currentScrollPosition: scrollTopOffset, menuHidden: true})


      }
      if(this.state.currentScrollPosition > scrollTopOffset){

        this.setState({navBarSmall: true, currentScrollPosition: scrollTopOffset, menuHidden: false})
      }

    }else{
      this.setState({navBarSmall: false, currentScrollPosition: scrollTopOffset, menuHidden})
    }

    if(scrollTopOffset < 300){
      if(this.state.showHomeButton)this.setState({showHomeButton: false})
    }

    if(scrollTopOffset > 300){

      if(!this.state.showHomeButton)this.setState({showHomeButton: true})
    }



  }

  goTo = (navLink)=>{
    this.toggleMobileMenu()
    let historyLength = this.context.router.history.length
    if(navLink === "betVideos"){
      window.scrollTo(0, 0);
      this.context.router.history.push("/brezplacninasveti")
    }else if(this.context.router.history.length[historyLength-1] !== "/")this.context.router.history.push("/")

    this.props.setNavigationActiveLink(navLink)
  }

  login = ()=>{
    this.toggleMobileMenu()
    this.props.loginDialogState(true)
  }

  toggleMobileMenu = ()=>{
    this.setState({mobileMenuIsOpened: !this.state.mobileMenuIsOpened})
  }

  render() {
    const { classes, auth } = this.props;
    const {navBarSmall} = this.state

    return (
      <AppBar className={classes.appBar}>
        <Hidden smDown>
          <Grid container justify="center">
            <Grid item xs={12} sm={12}>
              <Toolbar  className={navBarSmall ? this.state.menuHidden ? classes.toolBarSmallMenuHidden : classes.toolBarSmall : classes.toolBar}>
                <div style={navBarSmall ? {position:"absolute", bottom:0} : {display:"none"}}>
                  <div>
                    <img style={{padding:this.props.theme.spacing.unit *  1}} src="https://i.imgur.com/Boi2cXP.png" alt="gold" height="30" width="auto"/>
                  </div>

                </div>
                <div className={this.state.menuHidden ? classes.toolBarButtonMenuHidden : classes.toolBarButtonMenu}>
                  {
                    this.props.homeNav && (
                      <ButtonBase onClick={()=>this.goTo("home")}  className={classes.toolBarButton} >Domov</ButtonBase>
                    )
                  }

                  <ButtonBase onClick={()=>this.goTo("packages")}  className={classes.toolBarButton}>Ponudba</ButtonBase>
                  <ButtonBase onClick={()=>this.goTo("statistic")}  className={classes.toolBarButton}>Statistika</ButtonBase>
                  <ButtonBase onClick={()=>this.goTo("advices")}  className={classes.toolBarButton}>Stavne osnove</ButtonBase>

                </div>
              </Toolbar>
            </Grid>
          </Grid>
          {
            this.state.showHomeButton && (
              <Button onClick={()=>this.goTo("top")} variant="fab" color="primary" style={{position:"fixed", bottom: 50, right: 50}}>
                <UpIcon style={{fontSize: 25}}/>
              </Button>
            )
          }
        </Hidden>
        <Hidden mdUp>
          <Toolbar  className={classes.toolBarTopMobile}>
            <div style={{position:"absolute", bottom:5}}>
              <div>
                <img style={{padding:this.props.theme.spacing.unit *  1}} src="https://i.imgur.com/Boi2cXP.png" height="30" width="auto"/>
              </div>

            </div>

          </Toolbar>

        </Hidden>

        <div></div>
      </AppBar>
    );
  }
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = ({ auth, navigationData }) => {
  return {
    auth,
    navigationData
  };
};

export default connect(mapStateToProps, actions)( withStyles(style, { withTheme: true })(NavBar))



// WEBPACK FOOTER //
// ./src/components/navs/NavBar.js